// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let EdgePorticoApi = class EdgePorticoApi {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @param GetPortalConfigurationRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async porticoGetPortalConfiguration(GetPortalConfigurationRequestModel, x_program_id) {
        const _url_ = '/edge/portico/GetPortalConfiguration';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'GetPortalConfigurationRequestModel' is not null or undefined
        if (GetPortalConfigurationRequestModel === null || GetPortalConfigurationRequestModel === undefined) {
            throw new Error('Required parameter GetPortalConfigurationRequestModel was null or undefined when calling porticoGetPortalConfiguration.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(GetPortalConfigurationRequestModel, "GetPortalConfigurationRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PorticoGetPortalConfigurationDefaultResponse");
        }
        return response;
    }
};
EdgePorticoApi = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], EdgePorticoApi);
export { EdgePorticoApi };
//# sourceMappingURL=edgePorticoApi.js.map